var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div'), _vm._v(" "), _c('div', {
    staticClass: "d-flex justify-content-center align-items-center border border-danger"
  }, [_c('iframe', {
    attrs: {
      "src": _vm.$http.options.root + '/ppftz/pdf/ppftz' + '/' + _vm.$store.state.barpin.header.encoded_id,
      "width": "1200",
      "height": "800"
    }
  })])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ca6d8b1","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/ppftz/Perekaman/Step-3.vue
// module id = 369
// module chunks = 0